import { NgModule } from '@angular/core';
import {AppComponent } from '../app.component';
import { CommonModule } from '@angular/common';
import { HojasCallCenterRoutingModule } from './hojas-call-center-routing.module';
import { MatIconModule } from '@angular/material/icon';
import { MatSelectModule } from '@angular/material/select';
import { HojasCallCenterComponent } from './hojas-call-center.component';
import {MatButtonModule} from '@angular/material/button';
import { BdService } from './services/bd.service';
import { AlertArgumentarioComponent } from '../VistasGenericas/alert-argumentario/alert-argumentario.component';
import { MatDialogModule} from '@angular/material/dialog';
import { MatInputModule} from '@angular/material/input';
import { MatDatepickerModule} from '@angular/material/datepicker';
import { MatMomentDateModule, MAT_MOMENT_DATE_ADAPTER_OPTIONS } from '@angular/material-moment-adapter';
import { MatNativeDateModule, DateAdapter, MAT_DATE_LOCALE } from '@angular/material/core';
import { ReactiveFormsModule,FormsModule } from '@angular/forms';
import {MatTableModule} from '@angular/material/table';
import {MatAutocompleteModule} from '@angular/material/autocomplete';
import {MatProgressSpinnerModule, MatSpinner} from '@angular/material/progress-spinner';
import {MatProgressBarModule} from '@angular/material/progress-bar';
import {MatTooltipModule} from '@angular/material/tooltip';
import { AxaComponent } from './axa/axa.component';
import { GlassTalleresComponent } from './glass-talleres/glass-talleres.component';
import { BusquedaSiniestrosGtComponent } from './glass-talleres/busqueda-siniestros.component';
import { BusquedaTalleresGtComponent } from './glass-talleres/busqueda-talleres.component';
import { ListadoColaboradoresComponent as ListadoColaboradoresComponentAxa } from './axa/listado-colaboradores.component';
import { TipoLlamadaComponent as TipoLlamadaComponentAxa } from './axa/tipo-llamada.component';
import { TallerPreferenteComponent } from './taller-preferente/taller-preferente.component';
import { BuscarPeticionComponent } from './buscar-peticion/buscar-peticion.component';
import { GestionPeticionWebComponent } from './GestionPeticiones/gestion-peticion-web/gestion-peticion-web.component';
import { ListadoPeticionesComponent } from './listado-peticiones/listado-peticiones.component';
import { DetallePeticionComponent } from './GestionPeticiones/detalle-peticion/detalle-peticion.component';
import { ComentarioComponent } from './GestionPeticiones/detalle-peticion/comentario/comentario.component';
import { BuscadorTallerComponent } from './buscador-taller/buscador-taller.component';
import { BusquedaMatriculaComponent } from './busqueda-matricula/busqueda-matricula.component';
import { MatPaginator, MatPaginatorModule } from '@angular/material/paginator';
import { DetPeticionCorredoresComponent} from "./GestionPeticiones/det-peticion-corredores/det-peticion-corredores.component";
import {GestionPeticionAlpComponent} from "./GestionPeticiones/gestion-peticion-alp/gestion-peticion-alp.component";
import {DetallePeticionAlpComponent} from "./GestionPeticiones/detalle-peticion-alp/detalle-peticion-alp.component";
import {AbancaComponent} from "./abanca/abanca.component";
import { MatCardModule } from "@angular/material/card";
import { MatTabsModule } from "@angular/material/tabs";
import { ListadoComentariosComponent } from "./listado-comentarios/listado-comentarios.component";
import {MatSort, MatSortModule} from "@angular/material/sort";
import { LOCALE_ID } from '@angular/core';
import { registerLocaleData } from '@angular/common';
import localeEs from '@angular/common/locales/es';
import {CustomDateAdapter} from "./adapters/custom-date-adapter";
import {OpenComponent} from "./open/open.component";
import {PrimaComponent} from "./prima/prima.component";
import { VerificacionMutuaDialogComponent } from './verificacion-mutua-dialog/verificacion-mutua-dialog.component';
import { ListadoPolizasMutuaComponent } from './listado-polizas-mutua/listado-polizas-mutua.component';
import { SiniestroExtraDialogComponent } from './mutua-siniestroextradialog-component/siniestro-extra-dialog.component';

registerLocaleData(localeEs);
@NgModule({
  declarations:
  [
    HojasCallCenterComponent,
    OpenComponent,
    AlertArgumentarioComponent,
    TallerPreferenteComponent,
    GestionPeticionWebComponent,
    ListadoPeticionesComponent,
    DetallePeticionComponent,
    ComentarioComponent,
    BuscadorTallerComponent,
    BusquedaMatriculaComponent,
    DetPeticionCorredoresComponent,
    GestionPeticionAlpComponent,
    DetallePeticionAlpComponent,
    BuscarPeticionComponent,
    AxaComponent,
    GlassTalleresComponent,
    BusquedaSiniestrosGtComponent,
    BusquedaTalleresGtComponent,
    ListadoColaboradoresComponentAxa,
    TipoLlamadaComponentAxa,
    AbancaComponent,
    PrimaComponent,
    ListadoComentariosComponent,
    VerificacionMutuaDialogComponent,
    ListadoPolizasMutuaComponent,
    SiniestroExtraDialogComponent
  ],
  imports: [
    CommonModule,
    HojasCallCenterRoutingModule,
    MatSelectModule,
    MatIconModule,
    MatButtonModule,
    MatDialogModule,
    MatInputModule,
    MatDatepickerModule,
    MatNativeDateModule,
    FormsModule,
    ReactiveFormsModule,
    MatTableModule,
    MatAutocompleteModule,
    MatProgressSpinnerModule,
    MatProgressBarModule,
    MatTooltipModule,
    MatPaginatorModule,
    MatSortModule,
    MatCardModule,
    MatTabsModule
  ],
  providers:[BdService,
    { provide: MAT_DATE_LOCALE, useValue: 'es-ES' },
    { provide: LOCALE_ID, useValue: 'es-ES' },
    { provide: MAT_MOMENT_DATE_ADAPTER_OPTIONS, useValue: { useUtc: true }},
    { provide: DateAdapter, useClass: CustomDateAdapter },
    ],

  bootstrap:[AppComponent]
})
export class HojasCallCenterModule { }